module.exports = __webpack_public_path__ + "img/02.九龙柏（杨树田-摄）.aae3fc7e.jpg";